import { stringify } from 'qs';

/**
 * URL 업데이트 및 스크롤 이동 함수
 * @param queryObject - 업데이트할 쿼리 객체
 * @param delay - 딜레이(ms), 기본값: 100ms
 */
export const updateQueryAndScroll = (queryObject: Record<string, unknown>, delay = 100) => {
  setTimeout(() => {
    // URL 업데이트
    window.history.replaceState(null, '', `?${stringify(queryObject)}`);
    // 스크롤 맨 위로 이동
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, delay);
};
